<p-button #menuButton type="button" icon="pi pi-bars" size="large" class="me-1" styleClass="banner-menu-icon" (click)="visible = !visible" />
<div #myDiv></div>
<p-drawer
  #menuDrawer
  [appendTo]="myDiv"
  [(visible)]="visible"
  [baseZIndex]="10000"
  [modal]="false"
  [closable]="true"
  class="sidemenu"
  styleClass="sidebar-scrollbar primary-bg {{ (isSandboxLoan$ | async) ? 'static-message-active' : '' }}"
  header=" "
>
  <div class="list-group">
    @for (item of menuOptions$ | async; track item) {
      @if (item.hasSubmenu) {
        <div>
          <a class="button-link" (click)="item.toggleMenu = !item.toggleMenu"
            >{{ item.displayName
            }}<i class="fa-solid submenu-icon" [class.fa-angle-up]="item.toggleMenu" [class.fa-angle-right]="!item.toggleMenu"></i
          ></a>
          @for (subItem of item.submenu; track subItem) {
            <div class="link-wrapper" [ngClass]="{ disabled: subItem.disabled, 'd-none': subItem.hidden }">
              @if (item.toggleMenu) {
                <a
                  class="button-link submenu"
                  routerLinkActive="active"
                  [ngClass]="{ disabled: subItem.disabled }"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [routerLink]="[subItem.link]"
                  [pTooltip]="subItem.tooltip"
                  tooltipPosition="bottom"
                  >{{ subItem.displayName }}
                </a>
              }
            </div>
          }
        </div>
      }
      <div class="link-wrapper" [ngClass]="{ disabled: item.disabled, 'd-none': item.hidden }" [pTooltip]="item.tooltip">
        @if (!item.hasSubmenu) {
          <a
            class="button-link"
            routerLinkActive="active"
            [ngClass]="{ disabled: item.disabled }"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="[item.link]"
            >{{ item.displayName }}
          </a>
        }
      </div>
    }
  </div>
</p-drawer>
